import { Button, ButtonGroup } from '@blueprintjs/core'
import * as React from 'react'

export interface Props {
  page: number
  maxPages: number
  onPageChange: (nextPage: number) => void
}

const Pagination: React.FC<Props> = ({ page, maxPages, onPageChange }) => {
  return (
    <>
      <ButtonGroup style={{ display: 'flex', justifyContent: 'center', paddingBottom: 20, marginTop: 20 }}>
        <Button onClick={() => onPageChange(page - 1)} disabled={page === 1} icon="arrow-left" />
        <Button onClick={() => onPageChange(page + 1)} disabled={page >= maxPages} icon="arrow-right" />
      </ButtonGroup>
    </>
  )
}

export default Pagination
